import { LitElement, html } from '@hh/global.js'

class CollectionFilters extends LitElement {
  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.collectionDrawerEl = document.querySelector('collection-filter-drawer')

    this.handleFilterButton()
    this.handleDesktopSortDropdown()

    document.querySelector('main').classList.add('relative')
    this.closest('section').classList.add('sticky__filters')

    document.addEventListener(
      'scroll',
      this.setCollectionFilterBottom.bind(this),
      false
    )

    this.initBodyResizeObserver()

    this.setCollectionFilterBottom()
  }

  disconnectedCallback() {
    super.disconnectedCallback()

     this.bodyResizeObserver?.disconnect()
  }

  handleFilterButton() {
    const filterButtonsEl = this.querySelectorAll('.js-toggle-filter-button')
    const filterDrawerEl = document.querySelector('collection-filter-drawer')
    const productGridContainer = document.querySelector(
      '.js-collection-product-grid-container'
    )

    filterButtonsEl?.forEach((el) => {
      el.addEventListener('click', () => {
        el.classList.toggle('is-show')
        filterDrawerEl.toggleAttribute('open')
        productGridContainer.setAttribute('data-animate-switch', '')

        setTimeout(() => {
          productGridContainer.removeAttribute('data-animate-switch')
          productGridContainer.classList.toggle(
            'collection-product-grid__narrow'
          )
        }, 500)
      })
    })
  }

  handleDesktopSortDropdown() {
    const sortDropdown = this.querySelector('.js-sort-dropdown')
    const sortSelect = document.querySelector('.js-sort-select')

    sortDropdown.addEventListener('change', (e) => {
      if (sortSelect.value === e.target.value) return
      sortSelect.value = e.target.value
      sortSelect.dispatchEvent(new Event('change'))
    })
  }

  initBodyResizeObserver() {
    this.lastElTopAndBottom = { top: 0, bottom: 0 }

    this.bodyResizeObserver = new ResizeObserver(() => {
      const { top: elTop, bottom: elBottom } = this.getBoundingClientRect()
      if (
        elTop === this.lastElTopAndBottom.top &&
        elBottom === this.lastElTopAndBottom.bottom
      ) { return }

      this.lastElTopAndBottom.top = elTop
      this.lastElTopAndBottom.bottom = elBottom

      this.setCollectionFilterBottom()
    })

    this.bodyResizeObserver.observe(document.body)
  }

  setCollectionFilterBottom() {
    const { bottom: elBottom } = this.getBoundingClientRect()

    this.collectionDrawerEl.style.setProperty(
      '--hh-collection-filter-bottom',
      `${elBottom}px`
    )
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('collection-filters', CollectionFilters)
